export const bangGia = {
  sections: {
    list: { title: 'Bảng giá' },
    setup: { title: 'Thiết lập giá' },
    bookList: { title: 'Bảng giá' },
    quanLy: { title: 'Quản lý Bảng giá' },
    thietLap: { title: 'Thiết lập bảng giá' },
  },
  /** Tab trên header modal "Tạo / Sửa bảng giá" và hai tab màn thiết lập. */
  tabs: {
    info: 'Thông tin',
    scope: 'Phạm vi áp dụng',
    books: 'Bảng giá',
    products: 'Bảng giá hàng hóa',
  },
  fields: {
    code: 'Mã bảng giá',
    name: 'Tên bảng giá',
    startDate: 'Ngày bắt đầu',
    endDate: 'Ngày kết thúc',
    status: 'Trạng thái',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    onOffAction: 'Bật tắt',
    actions: 'Thao tác',
    formulaBase: 'Giá gốc',
    formulaOp: 'Phép tính',
    formulaValue: 'Giá trị',
    formulaUnit: 'Đơn vị',
    allowOutOfCatalog: 'Cho phép thêm hàng ngoài',
    warnOutOfCatalog: 'Cảnh báo hàng ngoài',
    branches: 'Chi nhánh áp dụng',
    productCode: 'Mã hàng',
    productName: 'Tên hàng',
    unit: 'Đơn vị tính',
    productGroup: 'Nhóm hàng',
    costPrice: 'Giá vốn',
    lastPurchasePrice: 'Giá nhập cuối',
    commonPrice: 'Bảng giá chung',
    salePrice: 'Giá bán',
    stock: 'Tồn kho',
  },
  /**
   * Card trong form (khớp ảnh mẫu banggia).
   * - `validity`: Card "Hiệu lực" — 2 datetime picker + radio Trạng thái
   * - `formula`: Card "Công thức giá" + dòng "Giá mới = ..."
   * - `cashier`: Card "Khi thu ngân lên đơn với bảng giá này"
   */
  sections2: {
    validity: 'Hiệu lực',
    formula: 'Công thức giá',
    formulaDesc:
      'Tạo công thức dựa trên giá vốn, giá nhập hoặc giá bán ở các bảng giá khác',
    cashier: 'Khi thu ngân lên đơn với bảng giá này',
    scopeBranch: 'Chi nhánh',
    scopeCustomerGroup: 'Nhóm khách hàng',
    scopeCreator: 'Người tạo giao dịch',
  },
  placeholders: {
    name: 'Nhập tên bảng giá',
    branch: 'Chọn chi nhánh',
    customerGroup: 'Chọn nhóm khách hàng',
    creator: 'Chọn người tạo giao dịch',
    search: 'Tìm kiếm',
    selectPriceBook: 'Chọn bảng giá',
  },
  /** Radio: Toàn bộ / Cụ thể (áp dụng cho cả 3 nhóm phạm vi) */
  radio: {
    all: 'Tất cả',
    specific: 'cụ thể',
    branchAllSystem: 'Toàn hệ thống',
    branchSpecific: 'Chi nhánh cụ thể',
    customerGroupAll: 'Tất cả',
    customerGroupSpecific: 'Nhóm khách hàng cụ thể',
    creatorAll: 'Tất cả',
    creatorSpecific: 'Người tạo giao dịch cụ thể',
    /** Cashier card */
    allowOutOfCatalog: 'Được phép thêm hàng hóa không có trong bảng giá',
    warnWhenOutOfCatalog: 'Gửi cảnh báo khi thêm hàng hóa không có trong bảng giá',
    onlyInCatalog: 'Chỉ được thêm hàng hóa có trong bảng giá này',
    /** Trạng thái bảng giá (tab Thông tin) */
    apDung: 'Áp dụng',
    chuaApDung: 'Chưa áp dụng',
  },
  formula: {
    /** Label "Giá mới = ..." trước dropdown nguồn */
    baseEquals: 'Giá mới =',
    /** Word "đến" giữa 2 datetime picker hiệu lực */
    to: 'đến',
    /** Tooltip 2 nút +/- */
    add: 'Cộng',
    remove: 'Trừ',
    /** Loại nguồn giá (dropdown bên trái) */
    selectPriceBook: 'Chọn bảng giá',
    giaVon: 'Giá vốn',
    giaNhapCuoi: 'Giá nhập cuối',
    searchPlaceholder: 'Tìm kiếm',
  },
  status: {
    AP_DUNG: 'Áp dụng',
    CHUA_AP_DUNG: 'Chưa áp dụng',
    all: 'Tất cả',
  },
  sort: {
    ma: 'Mã',
    ten: 'Tên',
    ngayTao: 'Ngày tạo',
  },
  filter: {
    searchPlaceholder: 'Mã hoặc tên bảng giá',
    statusSection: 'Trạng thái',
    sortSection: 'Sắp xếp',
    sortField: 'Trường sắp xếp',
    sortDir: 'Chiều sắp xếp',
    productSearch: 'Mã / tên hàng',
    maHangHoa: 'Mã hàng',
    tenHangHoa: 'Tên hàng',
    maNhomHang: 'Mã nhóm hàng',
    tenNhomHang: 'Tên nhóm hàng',
    group: 'Nhóm hàng',
    stockSection: 'Tồn kho',
    priceCompareSection: 'So sánh giá',
  },
  tonKho: {
    TAT_CA: 'Tất cả',
    CON_HANG: 'Còn hàng',
    HET_HANG: 'Hết hàng',
  },
  dieuKienGia: {
    NHO_HON: 'Nhỏ hơn',
    LON_HON: 'Lớn hơn',
    BANG: 'Bằng',
    NHO_HON_HOAC_BANG: '≤',
    LON_HON_HOAC_BANG: '≥',
  },
  giaSoSanh: {
    GIA_VON: 'Giá vốn',
    GIA_NHAP_CUOI: 'Giá nhập cuối',
  },
  loaiGiaGoc: {
    GIA_VON: 'Giá vốn',
    GIA_NHAP_CUOI: 'Giá nhập cuối',
  },
  toanTu: {
    CONG: 'Cộng (+)',
    TRU: 'Trừ (−)',
    NHAN: 'Nhân (×)',
    CHIA: 'Chia (÷)',
  },
  donVi: {
    VND: 'VND',
    PERCENT: '%',
  },
  titles: {
    add: 'Thêm bảng giá',
    edit: 'Sửa bảng giá',
    detail: 'Chi tiết bảng giá',
    priceList: 'Giá hàng hóa trong bảng',
    editPrice: 'Sửa giá bán',
    applyFormula: 'Áp dụng công thức giá',
  },
  actions: {
    skip: 'Bỏ qua',
    save: 'Lưu',
    downloadTemplate: 'Tải mẫu Excel',
    importPrice: 'Nhập giá (Excel)',
    exportPrice: 'Xuất giá (Excel)',
    applyFormula: 'Áp công thức',
    toggleColumns: 'Ẩn/hiện cột',
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
  },
  columnSections: {
    productInfo: 'Thông tin hàng',
    priceBooks: 'Bảng giá',
  },
  messages: {
    noData: 'Không có dữ liệu',
    loadError: 'Không tải được dữ liệu',
    loadDetailError: 'Không tải được chi tiết',
    createSuccess: 'Đã tạo bảng giá',
    updateSuccess: 'Đã cập nhật bảng giá',
    deleteSuccess: 'Đã xóa bảng giá',
    toggleSuccess: 'Đã đổi trạng thái',
    priceUpdateSuccess: 'Đã cập nhật giá bán',
    formulaSuccess: 'Đã áp dụng công thức',
    importSuccess: 'Import giá thành công',
    importFailed: 'Import giá thất bại',
    importEmpty: 'File không có dòng dữ liệu giá',
    importNoSheet: 'File Excel không có sheet dữ liệu',
    importDescription:
      'Tải mẫu (Mã hàng, Tên hàng, cột tùy chọn Bảng giá chung + cột từng bảng giá). Cột bảng giá chưa có trên hệ thống sẽ được tạo mới (chỉ tên). Ô trống bỏ qua.',
    exportSuccess: 'Đang tải file',
    confirmDelete: 'Xóa bảng giá «{name}»?',
    listSummary: 'Tổng số {count} bảng giá',
    gridSummary: '{count} hàng hóa',
    selectBook: 'Chọn bảng giá ở sidebar để xem và sửa giá.',
    noPriceBooks: 'Chưa có bảng giá. Thêm bảng giá để thiết lập giá hàng hóa.',
    multiBookHint:
      'Đang hiển thị {count} bảng giá — mỗi bảng giá là một cột giá. Bảng đầu tiên làm mốc phân trang.',
    confirmApplyFormula: 'Áp dụng công thức giá tự động cho toàn bộ hàng trong bảng?',
    /** Validate form tạo/sửa */
    nameRequired: 'Vui lòng nhập tên bảng giá',
    nameDuplicate: 'Tên bảng giá đã tồn tại',
    formulaRequired: 'Vui lòng chọn nguồn giá',
    dateRangeInvalid: 'Ngày kết thúc phải sau ngày bắt đầu',
    scopeBranchRequired: 'Vui lòng chọn chi nhánh áp dụng',
  },
  cellPrice: {
    applyThisOnly: 'Áp dụng công thức cho hàng hóa này',
    applyPage: 'Áp dụng công thức cho toàn bộ mã hàng trên trang',
    applyAll: 'Áp dụng công thức cho toàn bộ mã hàng',
    computeFromFormula: 'Tính giá theo công thức',
    apply: 'Áp dụng',
  },
  /** Tooltip các icon (ⓘ) trong form — tiêu đề tooltip */
  tooltips: {
    onlyInCatalogHint:
      'Khi chọn mục này, thu ngân chỉ có thể chọn hàng hóa có trong bảng giá. Hàng hóa ngoài bảng giá sẽ bị ẩn/greying-out ở màn hình bán hàng.',
  },
}
